<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.data.status)">
      <span>{{ params.data.status }}</span>
    </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  computed: {
    chipColor () {
      return (value) => {
        if (value === 'Paid' || value === 'Completed' || value === 'Approved' || value === 'Active' || value === 'Occupied' || value === 'Passed') return 'success'
        else  if (value === 'Partially Paid') return 'warning'
        else return 'danger'
      }
    }
  }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
